import { render, staticRenderFns } from "./thirdfifth.vue?vue&type=template&id=40aab773&"
import script from "./thirdfifth.vue?vue&type=script&lang=js&"
export * from "./thirdfifth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40aab773')) {
      api.createRecord('40aab773', component.options)
    } else {
      api.reload('40aab773', component.options)
    }
    module.hot.accept("./thirdfifth.vue?vue&type=template&id=40aab773&", function () {
      api.rerender('40aab773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/third/thirdfifth.vue"
export default component.exports